import i18n from '@/libs/i18n'

export default [
  {
    path: '/articles/doctor-settings', name: 'article-doctor-policy', component: () => import('@/views/pages/doctorPolicy/DoctorPolicy.vue'), meta: { resource: 'article', action: 'read' },
  },
  // *===============================================---*
  // *--------- ARTICLE ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/articles/list',
    name: 'pages-articles-list',
    component: () => import('@/views/pages/article/ArticlesList.vue'),
    meta: {
      resource: 'article',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('articles.mainVerticalMenu.articles'),
    },
  },
  {
    path: '/articles/add',
    name: 'pages-articles-add',
    component: () => import('@/views/pages/article/ArticleAdd.vue'),
    meta: {
      resource: 'article',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('articles.mainVerticalMenu.articles'),
    },
  },
  {
    path: '/articles/edit/:id',
    name: 'pages-articles-edit',
    component: () => import('@/views/pages/article/ArticleEdit.vue'),
    meta: {
      resource: 'article',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('articles.mainVerticalMenu.articles'),
    },
  },
  {
    path: '/articles/categories/list',
    name: 'pages-article-categories-list',
    component: () => import('@/views/pages/articleCategory/ArticleCategoryList.vue'),
    meta: {
      resource: 'articleCategory',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('articleCategories.mainVerticalMenu.articleCategories'),
    },
  },
  {
    path: '/articles/categories/add',
    name: 'pages-article-categories-add',
    component: () => import('@/views/pages/articleCategory/ArticleCategoryAdd.vue'),
    meta: {
      resource: 'articleCategory',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('articleCategories.mainVerticalMenu.articleCategories'),
    },
  },
  {
    path: '/articles/categories/edit/:id',
    name: 'pages-article-categories-edit',
    component: () => import('@/views/pages/articleCategory/ArticleCategoryEdit.vue'),
    meta: {
      resource: 'articleCategory',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('articleCategories.mainVerticalMenu.articleCategories'),
    },
  },
]
